import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../../src/api/user.api";
import Logo from "../../assets/images/86294Sized_AdVendoo_falt_RK_01.png";
import { errorMsg, success } from "../../utils/notifications";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEyeSlash } from "react-icons/fa";
// import { Navigate } from "react-router-dom";
import bgImg from "../../assets/images/Texture BG.jpg";
import loginImg from "../../assets/images/Log in Image.png";
function ResetPassword() {
  const initialData = {
    newPassword: "",
    confirmPassword: "",
  };
  const { token } = useParams(); // Retrieve token from URL params
  const navigate = useNavigate(); // Use navigate hook to navigate between routes
  const [resetPass, setResetPass] = useState(initialData);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleTogglePassword = (fieldName) => {
    if (fieldName === "password") {
      setShowPassword(!showPassword);
    } else if (fieldName === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const handleChange = (e) => {
    setResetPass({
      ...resetPass,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (resetPass.newPassword !== resetPass.confirmPassword) {
      errorMsg("Try Again", "Passwords do not match");
      return;
    }
    try {
      await resetPassword(token, resetPass.newPassword); // Pass token and new password to API
      success("Congratulations!", "You have successfully reset your password");
      navigate("/"); // Redirect to login page after successful reset
    } catch (error) {
      console.error("Error resetting password:", error);
      errorMsg("Error", "Failed to reset password. Please try again.");
    }
  };
  return (
    <>
      <div className="grid grid-cols-12">
        <div className="h-screen col-span-12 lg:col-span-6 md:col-span-12  ">
          <div className="pt-8">
            <img
              className="ml-5 md:ml-12 lg:ml-12 h-10 w-auto"
              src={Logo}
              alt="Your Company"
            />
          </div>
          <div className=" py-5 px-5 flex items-center justify-center h-3/4 md:h-[90%] lg:h-[90%]">
            <div className="px-3 lg:px-0 md:px-0 w-full md:w-3/5 lg:w-3/5">
              <div>
                <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900">
                  Forgot Password?
                </h2>
                <p className="text-base leading-6 text-gray-400 font-semibold">
                  Change your password here.
                </p>
              </div>

              <div className="mt-5">
                <div>
                  <form onSubmit={handleSubmit} method="POST" className="">
                    <div className="pb-4">
                      <div className="grid grid-cols-1 gap-x-6 gap-y-3.5 sm:grid-cols-6">
                        <div className="lg:col-span-12 md:col-span-12 col-span-12 relative">
                          <label
                            htmlFor="newPassword"
                            className="block text-base font-semibold leading-6 text-gray-800"
                          >
                            New Password
                          </label>
                          <div className="mt-2 relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              name="newPassword"
                              placeholder="New Password"
                              value={resetPassword.newPassword}
                              onChange={handleChange}
                              id="newPassword"
                              className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                              required
                            />
                            {/* Eye icon */}
                            <button
                              className="absolute inset-y-0 right-0 flex items-center pr-3"
                              onClick={() => handleTogglePassword("password")}
                              type="button"
                            >
                              {showPassword ? (
                                <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                              ) : (
                                <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="lg:col-span-12 md:col-span-12 col-span-12 relative">
                          <label
                            htmlFor="confirmPassword"
                            className="block text-base font-semibold leading-6 text-gray-800"
                          >
                            Confirm Password
                          </label>
                          <div className="mt-2 relative">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              placeholder="Confirm Password"
                              value={resetPassword.confirmPassword}
                              onChange={handleChange}
                              id="confirmPassword"
                              className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                              required
                            />
                            {/* Eye icon */}
                            <button
                              className="absolute inset-y-0 right-0 flex items-center pr-3"
                              onClick={() =>
                                handleTogglePassword("confirmPassword")
                              }
                              type="button"
                            >
                              {showConfirmPassword ? (
                                <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                              ) : (
                                <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-yellow px-3 py-2.5 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                      >
                        Reset Password & Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-screen hidden lg:block col-span-12 lg:col-span-6  sm:col-span-12 relative">
          <img
            className="h-full w-full object-cover"
            src={bgImg}
            alt="bg img"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <div className="flex items-center justify-center flex-col">
                <h1 className="w-96 my-4 text-4xl ">Welcome Back</h1>
                <p className="w-96 mb-5 text-xl">
                  Discover new oppurtunities in the Wold of ads
                </p>
              </div>
              <img className="w-auto h-96" src={loginImg} alt="bg img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
